import {
  PAYMENT_GATEWAY_SERVICES_START,
  PAYMENT_GATEWAY_SERVICES_SUCCESS,
  PAYMENT_GATEWAY_SERVICES_FAILURE,
  PAYMENT_GATEWAY_REQUEST_START,
  PAYMENT_GATEWAY_REQUEST_SUCCESS,
  PAYMENT_GATEWAY_REQUEST_FAILURE,
  PAYMENT_GATEWAY_VIEW_START,
  PAYMENT_GATEWAY_VIEW_SUCCESS,
  PAYMENT_GATEWAY_VIEW_FAILURE,
  PAYMENT_GATEWAY_GENERATE_START,
  PAYMENT_GATEWAY_GENERATE_SUCCESS,
  PAYMENT_GATEWAY_GENERATE_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  paymentGatewayServices: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
  },
  paymentGatewayRequest: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
  },
  paymentGatewayGenerate: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
  },
  paymentGatewayView: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
  },
};

const PaymentGatewayReducer = (state = initialState, action) => {
  switch (action.type) {

    case PAYMENT_GATEWAY_SERVICES_START:
      return {
        ...state,
        paymentGatewayServices: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case PAYMENT_GATEWAY_SERVICES_SUCCESS:
      return {
        ...state,
        paymentGatewayServices: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case PAYMENT_GATEWAY_SERVICES_FAILURE:
      return {
        ...state,
        paymentGatewayServices: {
          data: {},
          loading: true,
          error: action.error,
          buttonDisable: false,
        },
      };

    case PAYMENT_GATEWAY_REQUEST_START:
      return {
        ...state,
        paymentGatewayRequest: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case PAYMENT_GATEWAY_REQUEST_SUCCESS:
      return {
        ...state,
        paymentGatewayRequest: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case PAYMENT_GATEWAY_REQUEST_FAILURE:
      return {
        ...state,
        paymentGatewayRequest: {
          data: {},
          loading: true,
          error: action.error,
          buttonDisable: false,
        },
      };

    case PAYMENT_GATEWAY_VIEW_START:
      return {
        ...state,
        paymentGatewayView: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case PAYMENT_GATEWAY_VIEW_SUCCESS:
      return {
        ...state,
        paymentGatewayView: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case PAYMENT_GATEWAY_VIEW_FAILURE:
      return {
        ...state,
        paymentGatewayView: {
          data: {},
          loading: true,
          error: action.error,
          buttonDisable: false,
        },
      };
    
    case PAYMENT_GATEWAY_GENERATE_START:
      return {
        ...state,
        paymentGatewayGenerate: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: true,
        },
      };
    case PAYMENT_GATEWAY_GENERATE_SUCCESS:
      return {
        ...state,
        paymentGatewayGenerate: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: false,
        },
      };
    case PAYMENT_GATEWAY_GENERATE_FAILURE:
        return {
          ...state,
          paymentGatewayGenerate: {
            data: {},
            loading: true,
            error: action.error,
            buttonDisable: false,
          },
        };
      
    default: return state;
  }
};

export default PaymentGatewayReducer;
